import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DatatableService } from '../../../shared/services/datatable.service';
import { Router } from '@angular/router';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { SpringDatatablePagination } from '../../../shared/services/spring-integration/pagination/spring-datatable-pagination';
import { SpringDatatablePaginationService } from '../../../shared/services/spring-integration/pagination/spring-datatable-pagination.service';
import { HttpParams } from '@angular/common/http';
import { NotificationsService } from 'angular2-notifications';
import * as moment from 'moment';
import { ListarReusoCadastradoService } from './listar-reuso-cadastrado.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ExportCsvService } from '../../../shared/services/export-csv.service';
import { DocumentoHelper } from '../../../shared/utils/documento.helper';


@Component({
  selector: 'ngx-listar-reuso-cadastrado',
  templateUrl: './listar-reuso-cadastrado.component.html',
  styleUrls: ['./listar-reuso-cadastrado.component.scss']
})
export class ListarReusoCadastradoComponent implements OnInit {

  @ViewChild('myTable', { static: false })
  public myTable: DatatableComponent;
  public datatablePagination: SpringDatatablePagination = new SpringDatatablePagination();

  public formListaReusoCadastrado = null;
  public listaStatus = null;
  public cnpjCpf = null;
  public tableLimit = 10;
  public rowData: any;
  public columnsTabe = null;
  public customLogin = null;

  constructor(
    private formBuilder: FormBuilder,
    private datatableService: DatatableService,
    private service: ListarReusoCadastradoService,
    private router: Router,
    private spinnerService: NgxSpinnerService,
    private paginationService: SpringDatatablePaginationService,
    private notifications: NotificationsService,
    private exportCsvService: ExportCsvService,
  ) {

    this.paginationService.setDatatablePagination(this.datatablePagination);

    this.columnsTabe = [
      { columnName: "tipoReuso", newColumnName: "Tipo Reuso" },
      { columnName: "prioridade", newColumnName: "Prioridade" },
      { columnName: "status", newColumnName: "Status" },
      { columnName: "valor", newColumnName: "Valor" },
      { columnName: "dataCadastro", newColumnName: "Data Cadastro" },
      { columnName: "cnpj", newColumnName: "CNPJ Empresa" },
      { columnName: "dataCadastroEmpresa", newColumnName: "Data Cadastro Empresa" },
      { columnName: "dataInicioContrato", newColumnName: "Data Inicio Contrato" },
      { columnName: "email", newColumnName: "Email" },
      { columnName: "etapaIntegracao", newColumnName: "Etapa Integracao" },
      { columnName: "etapaIntegracaoCartao", newColumnName: "Etapa Integracao Cartao" },
      { columnName: "etapaIntegracaoConta", newColumnName: "Etapa Integracao Conta" },
      { columnName: "etapaIntegracaoContato", newColumnName: "Etapa Integracao Contato" },
      { columnName: "etapaIntegracaoEndereco", newColumnName: "Etapa Integracao Endereco" },
      { columnName: "id", newColumnName: "Id Empresa" },
      { columnName: "industria", newColumnName: "Industria" },
      { columnName: "inscricaoEstadual", newColumnName: "Inscricao Estadual" },
      { columnName: "nomeFantasia", newColumnName: "Nome Fantasia" },
      { columnName: "processadoraId", newColumnName: "Processadora Id" },
      { columnName: "processadoraStatus", newColumnName: "Processadora Status" },
      { columnName: "razaoSocial", newColumnName: "Razao Social" },
      { columnName: "statusEmpresa", newColumnName: "Status Empresa" },
      { columnName: "telefoneComercial", newColumnName: "Telefone Comercial" },
      { columnName: "ultimaAtualizacao", newColumnName: "Ultima Atualizacao" },
      { columnName: "cnpjReuso", newColumnName: "CNPJ Reuso" },
      { columnName: "dataCadastroReuso", newColumnName: "Data Cadastro Reuso" },
      { columnName: "dataInicioContratoReuso", newColumnName: "Data Inicio Contrato Reuso" },
      { columnName: "emailReuso", newColumnName: "Email Reuso" },
      { columnName: "etapaIntegracaoReuso", newColumnName: "Etapa Integracao Reuso" },
      { columnName: "etapaIntegracaoCartaoReuso", newColumnName: "Etapa Integracao Cartao Reuso" },
      { columnName: "etapaIntegracaoContaReuso", newColumnName: "Etapa Integracao Conta Reuso" },
      { columnName: "etapaIntegracaoContatoReuso", newColumnName: "Etapa Integracao Contato Reuso" },
      { columnName: "etapaIntegracaoEnderecoReuso", newColumnName: "Etapa Integracao Endereco Reuso" },
      { columnName: "idReuso", newColumnName: "Id Reuso" },
      { columnName: "industriaReuso", newColumnName: "Industria Reuso" },
      { columnName: "inscricaoEstadualReuso", newColumnName: "Inscricao Estadual Reuso" },
      { columnName: "nomeFantasiaReuso", newColumnName: "Nome Fantasia Reuso" },
      { columnName: "processadoraIdReuso", newColumnName: "Processadora Id Reuso" },
      { columnName: "processadoraStatusReuso", newColumnName: "Processadora Status Reuso" },
      { columnName: "razaoSocialReuso", newColumnName: "Razao Social Reuso" },
      { columnName: "statusReuso", newColumnName: "Status Reuso" },
      { columnName: "telefoneComercialReuso", newColumnName: "Telefone Comercial Reuso" },
      { columnName: "ultimaAtualizacaoReuso", newColumnName: "Ultima Atualizacao Reuso" },


    ];

  }

  getCpfCnpjMask(): string {
    const ctrl = this.formListaReusoCadastrado && this.formListaReusoCadastrado.get('cnpjCpf');
    const doForm = ctrl ? ctrl.value : null;
    const raw =
      this.cnpjCpf != null && String(this.cnpjCpf).trim() !== ''
        ? this.cnpjCpf
        : doForm;
    return DocumentoHelper.getMascaraCpfCnpj(raw);
  }

  formatarDocumento(valor: string | null | undefined): string {
    return DocumentoHelper.formatarDocumento(valor);
  }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.datatableService.subscribeTable(this.myTable);

    this.formListaReusoCadastrado = this.formBuilder.group({

      cnpjCpf: [null],

    });
  }

  buscaReuso(data: any, page?: any) {

    let params = new HttpParams();

    params = params.append('size', String(this.tableLimit))

    if (page && page != null) {
      params = params.append('page', page);
    }

    const docNorm = this.normalizarCnpjCpfParaBackend(data.cnpjCpf);
    if (docNorm !== '') {
      params = params.append('cpfCnpj', docNorm);

      this.spinnerService.show();

      this.service.listReusoCadastrado(params, (response => {

        this.rowData = response.content
        this.rowData = this.rowData.map((data) => {
          return {
            cnpj: data.empresaReuso.cnpj,
            razaoSocial: data.empresaReuso.razaoSocial,
            dataCadastro: moment(data.dataCadastro).format('DD/MM/YYYY'),
            valor: data.valor,
            tipoReuso: data.tipoReuso,
          };

        });

        this.spinnerService.hide();
        this.paginationService.setInfo(response);

      }), (error) => this.spinnerService.hide());

    } else {

      this.notifications.error("Campo CPF/CNPJ é obrigatório.");

    }
  }

  exportarXlsx(data?: any) {

    let params = new HttpParams();

    params = params.append('allElements', 'true');

    const docNorm = this.normalizarCnpjCpfParaBackend(data.cnpjCpf);
    if (docNorm === '') {

      this.notifications.error('Campo obrigatório, cnpjCpf!');
      this.datatablePagination.rowData = [null];
      this.datatablePagination.totalElements = 0;

    } else {

      params = params.append('cnpj', docNorm);

      this.service.listReusoCadastrado(params, (response => {

        if (response.content.length == 0) {
          this.spinnerService.hide();
          this.notifications.warn('Não há dados para o período informado!');
        }
        this.spinnerService.hide();
        this.rowData = response.content;
        this.rowData = this.rowData.map(data => {
          return {
            tipoReuso: data.tipoReuso,
            prioridade: data.prioridade,
            status: data.status,
            valor: data.valor,
            dataCadastro: moment(data.dataCadastro).format('DD/MM/YYYY'),
            cnpj: data.empresaPrincipal.cnpj,
            dataCadastroEmpresa: moment(data.empresaPrincipal.dataCadastro).format('DD/MM/YYYY'),
            dataInicioContrato: moment(data.empresaPrincipal.dataInicioContrato).format('DD/MM/YYYY'),
            email: data.empresaPrincipal.email,
            etapaIntegracao: data.empresaPrincipal.etapaIntegracao,
            etapaIntegracaoCartao: data.empresaPrincipal.etapaIntegracaoCartao,
            etapaIntegracaoConta: data.empresaPrincipal.etapaIntegracaoConta,
            etapaIntegracaoContato: data.empresaPrincipal.etapaIntegracaoContato,
            etapaIntegracaoEndereco: data.empresaPrincipal.etapaIntegracaoEndereco,
            id: data.empresaPrincipal.id,
            industria: data.empresaPrincipal.industria,
            inscricaoEstadual: data.empresaPrincipal.inscricaoEstadual,
            nomeFantasia: data.empresaPrincipal.nomeFantasia,
            processadoraId: data.empresaPrincipal.processadoraId,
            processadoraStatus: data.empresaPrincipal.processadoraStatus,
            razaoSocial: data.empresaPrincipal.razaoSocial,
            statusEmpresa: data.empresaPrincipal.status,
            telefoneComercial: data.empresaPrincipal.telefoneComercial,
            ultimaAtualizacao: moment(data.empresaPrincipal.ultimaAtualizacao).format('DD/MM/YYYY'),
            cnpjReuso: data.empresaReuso.cnpj,
            dataCadastroReuso: moment(data.empresaReuso.dataCadastro).format('DD/MM/YYYY'),
            dataInicioContratoReuso: moment(data.empresaReuso.dataInicioContrato).format('DD/MM/YYYY'),
            emailReuso: data.empresaReuso.email,
            etapaIntegracaoReuso: data.empresaReuso.etapaIntegracao,
            etapaIntegracaoCartaoReuso: data.empresaReuso.etapaIntegracaoCartao,
            etapaIntegracaoContaReuso: data.empresaReuso.etapaIntegracaoConta,
            etapaIntegracaoContatoReuso: data.empresaReuso.etapaIntegracaoContato,
            etapaIntegracaoEnderecoReuso: data.empresaReuso.etapaIntegracaoEndereco,
            idReuso: data.empresaReuso.id,
            industriaReuso: data.empresaReuso.industria,
            inscricaoEstadualReuso: data.empresaReuso.inscricaoEstadual,
            nomeFantasiaReuso: data.empresaReuso.nomeFantasia,
            processadoraIdReuso: data.empresaReuso.processadoraId,
            processadoraStatusReuso: data.empresaReuso.processadoraStatus,
            razaoSocialReuso: data.empresaReuso.razaoSocial,
            statusReuso: data.empresaReuso.status,
            telefoneComercialReuso: data.empresaReuso.telefoneComercial,
            ultimaAtualizacaoReuso: moment(data.empresaReuso.ultimaAtualizacao).format('DD/MM/YYYY'),

          }
        })

        this.exportCsvService.exportCsv(this.rowData, this.columnsTabe, ';', 'reusoCadastrado');

      }), null);

    }

  }

  previousPage() {
    this.router.navigate(['/iot-dashboard']);
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

  private normalizarCnpjCpfParaBackend(value: any): string {
    if (value == null) {
      return '';
    }
    const str = String(value);
    if (str === '' || str === 'null') {
      return '';
    }
    const tipo = DocumentoHelper.detectarTipoDocumento(str);
    return DocumentoHelper.normalizarParaEnvio(str, tipo);
  }

}
